module.exports = __webpack_public_path__ + "static/media/logo-spmr.00e861ce.png";